import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";

// import { getAllCampaignsForCreatorCall, getReviews, getSingleBrandCall } from "Common/Repository";
import { getAllCampaignsForCreatorCall, getReviews, getSingleBrandCall } from "actions/brandDetailsAction";

const initialState = {
    loading: false,
    brandDetails: {},
    reviewData: [],
    approvedCollab: [],
    collabCount: 0,
    averageRating: null,
    reviewCount: 0,
    errors: null,
    brandCampaignsData: [],
    brandCampaignsLoading: false,
    brandDetailsCampaignsCurrentPage: 1,
    brandDetailsCampaignsTotalPages: null,
};

const brandDetailsSlice = createSlice({
    name: 'brandDetails',
    initialState,
    reducers: {
        setBrandDetailsCampaignsCurrentPage: (state, action) => {
            state.brandDetailsCampaignsCurrentPage = action?.payload;
        },
        setBrandDetails: (state, action) => {
            state.brandDetails = action.payload;
        },
        setReviewData: (state, action) => {
            state.reviewData = action.payload;
        },
        setApprovedCollab: (state, action) => {
            state.approvedCollab = action.payload;
        },
        setCollabCount: (state, action) => {
            state.collabCount = action.payload;
        },
        setAverageRating: (state, action) => {
            state.averageRating = action.payload;
        },
        setReviewCount: (state, action) => {
            state.reviewCount = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReviews.pending, (state) => {
                state.errors = null;
            })
            .addCase(getReviews.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(getReviews.rejected, (state, action) => {
                state.loading = false;
                state.errors = action.error.message;
            })
            .addCase(getAllCampaignsForCreatorCall.pending, (state) => {
                state.errors = null;
                state.brandCampaignsLoading = true;
            })
            .addCase(getAllCampaignsForCreatorCall.fulfilled, (state, action) => {
                state.brandCampaignsData = action?.payload?.data?.data;
                state.brandDetailsCampaignsCurrentPage = action?.payload?.data?.current_page;
                state.brandDetailsCampaignsTotalPages = action?.payload?.data?.last_page;
                state.brandCampaignsLoading = false;
            })
            .addCase(getAllCampaignsForCreatorCall.rejected, (state, action) => {
                state.brandCampaignsLoading = false;
                state.errors = action.error.message;
            })
            .addCase(getSingleBrandCall.pending, (state) => {
                state.errors = null;
            })
            .addCase(getSingleBrandCall.fulfilled, (state, action) => {
                state.reviewData = action?.payload?.data?.reviews?.reviews;
                state.reviewCount = action?.payload?.data?.reviews?.total_reviews;
                state.averageRating = action?.payload?.data?.reviews?.average_rating;
                state.loading = false;
            })
            .addCase(getSingleBrandCall.rejected, (state, action) => {
                state.loading = false;
                state.errors = action.error.message;
            })
            .addCase(logout, (state) => {
                state.brandDetails = {};
                state.reviewData = [];
                state.approvedCollab = [];
                state.collabCount = 0;
                state.averageRating = null;
                state.reviewCount = 0;
                state.errors = null;
            });
    },
});

export const {
    setLoading,
    setBrandDetails,
    setBrandDetailsCampaignsCurrentPage,
    setReviewData,
    setApprovedCollab,
    setCollabCount,
    setAverageRating,
    setReviewCount,
    setErrors
} = brandDetailsSlice.actions;
export default brandDetailsSlice.reducer;
